import Maps from "./ClassMaps";
import L from "leaflet";

// Map Proposition Init
const mapProposition = document.getElementById('mapPropositionReport')

if (mapProposition) {
    const lng = mapProposition.getAttribute('data-long')
    const lat = mapProposition.getAttribute('data-lat')
    const zoom = mapProposition.getAttribute('data-zoom')
    const markerToSave = document.querySelector('[data-key="field_62d6b31bd9c99"] input[type=text]')
    const addressGroup = document.querySelector('[data-key="field_62d7f8162437c"]')

// Init the Maps Class
    const Map = new Maps(lng, lat, zoom)

// Init the PostsQuery Class
    const Query = new PostsQuery()

// Init the Map
    Map.init

// Get bounds at inib
    const bounds = Map.map.getBounds()
// Make translation
    Map.doTranslation()

// Add the control to the map
    Map.control


    /*
    * On click authorize to drag a marker
    * and edit his informations inside his ACF repeater field
    * */

    /*
    function onMapClick(e) {
        const markerMap = Map.markerMap(e.latlng.lat, e.latlng.lng);
        let geoJSON = Map.createElement(markerMap)
        console.log(geoJSON)
    }

    Map.map.on('click', onMapClick);


    !!geoLocate &&
    geoLocate.querySelector('a').addEventListener('click',function(){
        if(geoLocate.classList.contains('active')){
            geoLocate.classList.remove('active')
        }
    })

    */
    function setMarkerToSave(value) {
        markerToSave.value = value
        // Let ACF clear the validation error of the hidden field
        markerToSave.dispatchEvent(new Event('change', {bubbles: true}))
    }

    /*
    * Mirror the ACF validation error of the hidden marker field on the map
    * */
    const mapWrapper = mapProposition.closest('.wrapper_reportmap')
    const markerFieldKey = 'field_62d6b31bd9c99'

    function showMapError(message) {
        mapWrapper.classList.add('has-error')
        mapProposition.setAttribute('aria-invalid', 'true')

        if (!mapWrapper.querySelector('.acf-error-message')) {
            mapProposition.insertAdjacentHTML('beforebegin', '<div class="acf-notice -error acf-error-message" role="alert"><p></p></div>')
        }
        mapWrapper.querySelector('.acf-error-message p').textContent = message
    }

    function hideMapError() {
        mapWrapper.classList.remove('has-error')
        mapProposition.removeAttribute('aria-invalid')
        mapWrapper.querySelector('.acf-error-message')?.remove()
    }

    if (typeof acf !== 'undefined') {
        acf.addAction('invalid_field', (field) => {
            if (field.get('key') === markerFieldKey) {
                showMapError('Veuillez placer un marqueur sur la carte.')
            }
        })

        acf.addAction('valid_field', (field) => {
            if (field.get('key') === markerFieldKey) {
                hideMapError()
            }
        })
    }

    Map.map.on(L.Draw.Event.CREATED, (e) => {
        console.log(e)

        const markerMap = Map.markerMap(e.layer._latlng.lat, e.layer._latlng.lng);
        let geoJSON = Map.createElement(markerMap)
        console.log(geoJSON)
        setMarkerToSave(geoJSON)

        Map.queryAddressByLatLng(e.layer._latlng, addressGroup)
        // Reset Geolocation if active
        let geoLocate = document.querySelector('.leaflet-control-locate')
        if (geoLocate.classList.contains('active')) {
            let click = new Event('click');
            geoLocate.querySelector('a').dispatchEvent(click)
        }
    })

    function onLocationFound(e) {
        console.log(e)
        const markerMap = Map.markerMap(e.latlng.lat, e.latlng.lng);
        let geoJSON = Map.createElement(markerMap)
        console.log(geoJSON)
        setMarkerToSave(geoJSON)
        Map.queryAddressByLatLng(e.latlng, addressGroup)
    }

    Map.map.on('locationfound', onLocationFound);

    Map.map.on('geosearch/showlocation', function (e) {
        console.log(e)
        let latlng = {lat: e.location.y, lng: e.location.x}
        const markerMap = Map.markerMap(e.location.y, e.location.x);
        let geoJSON = Map.createElement(markerMap)
        console.log(geoJSON)
        setMarkerToSave(geoJSON)
        Map.queryAddressByLatLng(latlng, addressGroup)
        // Reset Geolocation if active
        let geoLocate = document.querySelector('.leaflet-control-locate')
        if (geoLocate.classList.contains('active')) {
            let click = new Event('click');
            geoLocate.querySelector('a').dispatchEvent(click)
        }
    })

}

function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../../', true, /\.(png|jpe?g|gif|svg)$/));
